import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export const AboutSection = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-[#FAF9F7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative fade-in-up">
            <div className="relative overflow-hidden rounded-lg shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1600261669797-1bb7b27939be?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Travelers on Ganga River"
                className="w-full h-[500px] object-cover transform hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#6B4E37]/30 to-transparent"></div>
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#C4B5A0] rounded-full opacity-20 -z-10"></div>
          </div>

          {/* Content Side */}
          <div className="space-y-6 fade-in-up" style={{ animationDelay: '0.2s' }}>
            <h2 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] leading-tight">
              {t('aboutTitle')}
            </h2>
            
            <blockquote className="border-l-4 border-[#C4B5A0] pl-6 italic text-xl text-[#6B4E37] font-serif">
              "{t('aboutQuote')}"
            </blockquote>
            
            <p className="text-lg text-[#8B7D6B] leading-relaxed">
              {t('aboutText')}
            </p>

            {/* Why Choose Us Mini Cards */}
            <div className="grid grid-cols-2 gap-4 pt-6">
              <div className="p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <h4 className="font-medium text-[#2C2C2C] mb-1">{t('transparency')}</h4>
                <p className="text-sm text-[#8B7D6B]">{t('transparencyDesc')}</p>
              </div>
              <div className="p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <h4 className="font-medium text-[#2C2C2C] mb-1">{t('handmade')}</h4>
                <p className="text-sm text-[#8B7D6B]">{t('handmadeDesc')}</p>
              </div>
              <div className="p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <h4 className="font-medium text-[#2C2C2C] mb-1">{t('virtualTours')}</h4>
                <p className="text-sm text-[#8B7D6B]">{t('virtualToursDesc')}</p>
              </div>
              <div className="p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <h4 className="font-medium text-[#2C2C2C] mb-1">{t('soloFriendly')}</h4>
                <p className="text-sm text-[#8B7D6B]">{t('soloFriendlyDesc')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};